import { constants } from "../constants/redux-constants";

export const set_person_details = (payload) => {
  return { type: constants.SET_PERSON_DATA, payload };
};
export const set_practitioner_details = (payload) => {
  return { type: constants.SET_PRACTITIONER_DATA, payload };
};
export const set_organistion_details = (payload) => {
  return { type: constants.SET_ORGANISATION_DATA, payload };
};
export const set_related_persons_details = (payload) => {
  return { type: constants.RELATED_PERSONS_DATA, payload };
};
export const set_active_person_id = (payload) => {
  return { type: constants.ACTIVE_PERSON_ID, payload };
};
export const set_current_user_setting = (payload) => {
  return { type: constants.SET_CURRENT_USER_SETTINGS, payload };
};
export const set_dashboard_selected_widgets = (payload) => {
  return {type : constants?.APP?.SET_DASHBOARD_SELECTED_WIDGETS , payload}
}

export const set_voice_edit_setting = (payload) => {
  return { type: constants.SET_VOICE_EDIT_SETTINGS, payload };
};
export const set_user_template_preferences = (payload) => {
  return { type: constants.SET_USER_TEMPLATE_PREFERENCES, payload };
};
export const set_temp_data = (payload) => {
  return { type: constants.SET_TEMP_DATA, payload };
};
export const set_temp_data_reset = (payload) => {
  return { type: constants.SET_TEMP_DATA_RESET, payload };
};
export const append_temp_data = (payload) => {
  return { type: constants.APPEND_TEMP_DATA, payload };
};
export const set_current_user_practice_data = (payload) => {
  return { type: constants?.SET_CURRENT_USER_PRACTICE_DATA, payload };
};
export const set_is_logging_out = (payload) => {
  return { type: constants?.LOGGING_OUT, payload };
};
export const set_user_roles = (payload) => {
  return { type: constants.SET_USER_ROLES, payload };
};
export const set_roles_loaded = (payload) => {
  return { type: constants.SET_ROLES_LOADED, payload };
};
export const set_user_permissions = (payload) => {
  return { type: constants.SET_USER_PERMISSIONS, payload };
};
